<div class="chip"

     [style.width]="'fit-content'"
     [style.color]="mode == 'outline' ? '#000' : '#FFF'"
     [style.border]="mode == 'outline' ? 'solid 1px ' : 'none'"
     [style.border-color]="mode == 'outline' ? colors[color] : 'trasparent'"

     [style.background-color]="mode == 'default' ? colors[color] : 'trasparent'">
     @if(editarLabel) {
      <div class="container-verde">
        <input type="text" class="input-verde" [formControl]="control" />
      </div>
     } @else {
       {{ label }}
     }
  @if(edit) {
    @if(!editarLabel) {
      <span class="material-symbols-outlined icon" [appTooltip]="'Editar'" [tooltipPosition]="'right'" (click)="editar()">
        edit
      </span>
    }
  }

  @if(editarLabel) {
    <span class="material-symbols-outlined icon" [appTooltip]="'Salvar'" [tooltipPosition]="'right'" (click)="emitirControl()">
      check
    </span>
    <span class="material-symbols-outlined icon" [appTooltip]="'Retornar'" [tooltipPosition]="'right'" (click)="pegarValor()">
      close
    </span>
  }@else {
    <span class="material-symbols-outlined icon" (click)="clickAction(label)" [appTooltip]="'Excluir'" [tooltipPosition]="'right'">
      close
    </span>
  }

</div>
